import { render, staticRenderFns } from "./examRecords.vue?vue&type=template&id=15f8316f&scoped=true&"
import script from "./examRecords.vue?vue&type=script&lang=js&"
export * from "./examRecords.vue?vue&type=script&lang=js&"
import style0 from "./examRecords.vue?vue&type=style&index=0&id=15f8316f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8316f",
  null
  
)

export default component.exports